import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const DisputesPage = lazy(() => import('@/pages/disputes'));

export const Route = createFileRoute('/disputes')({
  component: function DisputesRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <DisputesPage />
      </Suspense>
    );
  },
});
